/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";
import './VcInstructions.css'

import centralSystem from 'assets/img/mockups/central-system-mockup.png';
import voiceConditioningProduct from 'assets/img/mockups/listen-first-ipad.png';
import appStore from 'assets/img/mockups/download-appstore.svg';
import playStore from 'assets/img/mockups/download-googleplay.svg';

import { Link } from 'react-router-dom'; 


// reactstrap components
import {
  Badge,
  Container,
  Row,
  Col,

} from "reactstrap";

class VcInstructions extends React.Component {

  render() {
    return (
      <>
        <section className="section section-lg vc-instructions text-center">
          <Container className="instructions-container">
            <h1 className="mb-5">Payment Confirmed</h1>
            <h5 className="mb-4">
                Thank you! Your payment has been successfully processed. <br/>
                To get started, please install the application on your Device.
            </h5>
            <Row className="row-grid align-items-center mb-5 ">
              <Col className="order-md-1 vc-product-1" md="6">
                <div className="blob"></div>
                <img
                  alt="..."
                  className="img-fluid product-img-1 "
                  src={voiceConditioningProduct}
                />

              </Col>
              <Col className="order-md-2 " md="6">
                <Row className="pl-5">
                    <Col md="6">
                        <a 
                            href="" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                        >
                            <img
                                alt="Download on the App Store" 
                                className="img-fluid store-link"
                                src={appStore} 
                            />
                        </a>
                    </Col >
                    <Col md="6">
                        <a 
                            href="" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                        >
                            <img
                                alt="Download on the App Store" 
                                className="img-fluid store-link"
                                src={playStore} 
                            />
                        </a>
                    </Col>
                </Row>
              </Col>
              

            </Row>


            <h5 className="mb-0">
                Once downloaded, your administrator can manage your devices through our central system.
            </h5>
            <h6 className="mb-5">Please note that the number of devices available to you is based on your purchased plan.</h6>

            <Row className="row-grid align-items-center">

        
                <Col className="order-md-1 elcar-product-2" md="6">
                    <img
                    alt="..."
                    className="img-fluid"
                    src={centralSystem}
                    />



                </Col>

              <Col className="order-md-2 text-left" md="6">
                <div className="pr-md-5">

                    <ol className="mt-5 mb-5">
                        <li className="py-1">
                            Access the Central System
                        </li>
                        <li className="py-1">
                            Setup your personal or institutional profile
                        </li>
                        <li className="py-1">
                            Navigate to the "Devices" section and register your device 
                            <ol>
                                <li className="py-1">
                                    For Institutional Plans - Navigate to the "Administrator" section to add 
                                    Administrators
                                </li>
                            </ol>
                        </li>
                        <li className="py-1">
                            Check your application reports in the “App Reporting” Section
                        </li>
                    </ol>

                    <Link 
                        to="/home" 
                        className="btn btn-primary btn-icon mb-3 mb-sm-0" 
                        id="btn-primary"
                    >
                        <span className="btn-inner--text">Coming soon</span>
                    </Link>

                </div>
              </Col>



            </Row>

          </Container>
        </section>

      </>
    )
  }
}

export default VcInstructions;